

import React from "react";
import { IconProps } from ".";

export const AddTemplates = ({
  className = '',
  color = '#6E6B8C',
  width = '21px',
  height = '20px'
}: IconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.83341 15.0001V5.00008H13.8052V3.33342H3.00008C2.53984 3.33342 2.16675 3.70651 2.16675 4.16675V15.8334C2.16675 16.2937 2.53984 16.6667 3.00008 16.6667H18.0001C18.4603 16.6667 18.8334 16.2937 18.8334 15.8334V8.35628H17.1667V15.0001H3.83341Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M7.09619 3.62523L7.09619 16.3745L8.76286 16.3745L8.76286 3.62523L7.09619 3.62523Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M2.48712 9.94995L18.8333 9.94995V8.28328L2.48712 8.28328V9.94995Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M18.8321 1.80835L17.1654 1.80835V3.46428L15.5095 3.46428V5.13095H17.1654V6.78682L18.8321 6.78682V5.13095L20.488 5.13095V3.46428L18.8321 3.46428V1.80835Z" fill={color} />
  </svg>
);
